import {RepeatWrapping, TextureLoader, Vector2} from 'three';
import {mapTextureNames, textureWrappingNames} from '../materials/MaterialPropertyMaps';

const MaterialTextureLoader = (texturePath, newTextureSet, newMaterialProps, callFunc) => {
  
  const getTexName = mapTextureNames();
  const loadTextures = [];
  
  // from new material obj - extract textures refs
  Object.keys(newTextureSet).forEach((textureName) => {
    loadTextures.push([textureName, newTextureSet[textureName]]);
  });
  
  // load texture
  const loadTexture = (texDataArray) => {
    
    const texName = getTexName.get(texDataArray[0]);
    const filePath = texturePath + texDataArray[1];
    
    const loader = new TextureLoader();
    
    return new Promise((resolve, reject) => {
      loader.load(filePath, loadedFile => {
        
        if (texName[1] && newMaterialProps['textureTiling']) {
          
          let wrap;
          if (newMaterialProps.wrap) {
            const wrapName = textureWrappingNames();
            wrap = wrapName.get(newMaterialProps.wrap)
          }else{
            wrap = RepeatWrapping;
          }
          
          loadedFile.wrapS = loadedFile.wrapT = wrap;
          loadedFile.repeat = new Vector2(newMaterialProps['textureTiling'], newMaterialProps['textureTiling']);
        }
        
        loadedFile.name = texName[0];
        resolve(loadedFile);
        
      }, error => {
        
        reject(error);
        
      });
    });
  }
  
  // load texture set
  const loadTextureSet = (texDataArray) => {
    
    return Promise.all(texDataArray.map((textureData) => {
      return loadTexture(textureData);
    }));
    
  };
  
  // get texture set
  loadTextureSet(loadTextures)
    
    .then((textures) => {
      
      callFunc(textures);
      
    })
    .catch(err => console.log('error - tex load set error', err))
    .finally();
  
};

export default MaterialTextureLoader;

